const NO_LINKS_TAGS_SCRIPTS = /^(?!.*(?:<.*?>|<\/?.*?>|<script|<\/script>|http|www|&#x?[0-9a-fA-F]+;|&#\d+;|\\u[0-9a-fA-F]{4}|&lt;|&gt;|&quot;|&apos;|&amp;|&#706;|&#707;|on[a-z]*=['"][^'"]*alert\([^)]*\)['"][^a-z]*|javascript:)).*$/;

const validate = (values) => {
    const errors = {};
    if (!values.login) {
        errors.login = 'Email field shouldn\'t be empty';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.login)) {
        errors.login = 'Invalid email address';
    }
    if (!values.password) {
        errors.password = 'Password field shouldn\'t be empty';
    } else if (values.password.length < 10) {
        errors.password = 'Must be at least 10 characters';
    } else if (values.password.length > 50) {
        errors.password = 'Must be at most 50 characters';
    } else if (/\s/.test(values.password)) {
        errors.password = 'Cannot contain whitespace characters';
    } else if (!/\d/.test(values.password)) {
        errors.password = 'Must contain at least 1 digit';
    } else if (!/[a-z]/.test(values.password)) {
        errors.password = 'Must contain at least 1 lowercase letter';
    } else if (!/[A-Z]/.test(values.password)) {
        errors.password = 'Must contain at least 1 capital letter';
    } else if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(values.password)) {
        errors.password = 'Must contain at least 1 special character';
    } else if (!NO_LINKS_TAGS_SCRIPTS.test(values.password)) {
        errors.password = 'Must not contain links, scripts, or HTML tags';
    }

    return errors;
};

export default validate;
